/** Registry of mini-calculators inside the Calculators OS app. */

export type CalculatorScope = "client" | "firm" | "none";

export type CalculatorDefinition = {
  id: string;
  label: string;
  description: string;
  scope: CalculatorScope;
};

export const CALCULATOR_REGISTRY: CalculatorDefinition[] = [
  {
    id: "plan-fees",
    label: "Plan fees",
    description: "Draft and check Octopus fee tables per plan before client disclosure.",
    scope: "client",
  },
  {
    id: "plan-features",
    label: "Plan features",
    description: "Summarise plan features into a comparison table.",
    scope: "client",
  },
  {
    id: "portfolio-assessment",
    label: "Portfolio assessment",
    description: "Existing-client portfolio assessment (Progeny CA-3.4.1).",
    scope: "client",
  },
  {
    id: "pension-carry-forward",
    label: "Pension carry forward",
    description: "Annual allowance, tapering, MPAA and three-year carry forward by tax year.",
    scope: "client",
  },
];

const BY_ID = new Map(CALCULATOR_REGISTRY.map((c) => [c.id, c]));

export function getCalculatorDefinition(
  calculatorId: string | undefined | null,
): CalculatorDefinition | undefined {
  if (!calculatorId) return undefined;
  return BY_ID.get(calculatorId);
}

export function listCalculators(): CalculatorDefinition[] {
  return CALCULATOR_REGISTRY;
}
